export default {
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  OPEN_MODAL_MULTI: 'OPEN_MODAL_MULTI',
  CLOSE_MODAL_MULTI: 'CLOSE_MODAL_MULTI',
}
